var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("최초 전송 시간")]),_c('td',[(_vm.pushFirstDate)?_c('span',[_vm._v(_vm._s(_vm.$utils.timeText(_vm.pushFirstDate)))]):_c('span',[_vm._v("-")])])])}
var staticRenderFns = []

export { render, staticRenderFns }